import React from 'react';

export const AuthErrorMessage = ({ error, className }) => {
  return <p className={`${className} authFormErrorText m-0`}>{error}</p>;
};
